<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Electivas</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear electiva</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <b-col lg="4">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-2" description="Ejemplo: Guitarra II">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre de la electiva"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group id="input-group-2" label="Descripción:" label-for="input-2" description="Puede agregar una breve descripción.">
                <b-form-input id="input-2" v-model="form.description" placeholder="Descripción de la electiva"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group id="input-group-2" label="Asignatura:" label-for="input-2">
                <multiselect v-model="form.subjectSelected" :options="subjects" :multiple="false" :taggable="true" label="name" track-by="id"
                  select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                  placeholder="Seleccione una opción">
                </multiselect>
              </b-form-group>
            </b-col>
          </div>
          <b-row>
            <b-col lg="4">
              <b-form-group id="input-group-3" label="Docente titular:" label-for="input-2">
                <multiselect v-model="form.tenuredTeachersSelected" :options="teachers" :multiple="false" :taggable="true" label="fullName" track-by="id"
                  select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                  placeholder="Seleccione una opción">
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group id="input-group-4" label="Docente auxiliar:" label-for="input-2">
                <multiselect v-model="form.assistantTeachersSelected" :options="teachers" :multiple="false" :taggable="true" label="fullName" track-by="id"
                  select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                  placeholder="Seleccione una opción">
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="¿Tiene evaluación semestral?">
                <b-form-checkbox switch  v-model="form.extraPeriodEvaluation"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4">
              <b-form-group label="Seleccionar Sistema de evaluación:">
                <b-form-select v-model="form.range.idQualificationSystem" :options="evaluationSystems" :disabled="true"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Seleccionar rango de valoración:">
                <b-form-select v-model="form.idQualificationRange" :options="ranges"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="checkEvaluationSystem(form.range.idQualificationSystem, 'QUANTITATIVE')">
              <b-form-group label="Seleccionar la planilla de evaluación:">
                <b-form-select v-model="form.templateGradeSelected" :options="templateGradeOptions"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de áreas</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <b-table striped hover :fields="columns" :items="data" head-variant="light" fixed responsive>
                <template #cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template #cell(evaluationSystem)="data">
                  {{  ((data.item.range && data.item.range.idQualificationSystem !== null)) ? (evaluationSystems.find((e) => e.value === data.item.range.idQualificationSystem)).text : 'Sin asignar'}}
                </template>
                <template #cell(actions)="data">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Editar</span>
                    </template>
                    <button type="button" class="btn btn-outline-secondary mr-2 mb-2" @click="openModal(data.item)">
                      <i class="fa fa-pencil text-blue" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Eliminar</span>
                    </template>
                    <button type="button" class="btn btn-outline-secondary mr-2 mb-2" @click="deleteModal(data.item)">
                      <i class="fa fa-close text-red" />
                    </button>
                  </a-tooltip>
                </template>
              </b-table>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-elective" ref="modal" title="Editar electiva" hide-footer size="xl" >
      <b-form @submit="editElective" ref="editElectiveForm">
        <div class="row">
          <b-col lg="4">
            <b-form-group id="edit-elective-input-group-1" label="Nombre:" label-for="input-2" description="Ejemplo: Guitarra II">
              <b-form-input id="edit-elective-input-1" v-model="electiveToEdit.name" required placeholder="Ingrese el nombre de la electiva"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group id="edit-elective-input-group-2" label="Descripción:" label-for="input-2" description="Puede agregar una breve descripción.">
              <b-form-input id="edit-elective-input-2" v-model="electiveToEdit.description" placeholder="Descripción de la electiva"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group id="edit-elective-input-group-2" label="Asignatura:" label-for="input-2">
              <b-form-select v-model="electiveToEdit.subjectSelected" :options="subjects" value-field="id"
              text-field="name"></b-form-select>
            </b-form-group>
          </b-col>
        </div>
        <b-row>
          <b-col lg="4">
            <b-form-group id="edit-elective-input-group-3" label="Docente titular:" label-for="input-2">
              <b-form-select v-model="electiveToEdit.tenuredTeachersSelected" :options="teachers" value-field="id" text-field="fullName"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group id="edit-elective-input-group-4" label="Docente auxiliar:" label-for="input-2">
              <b-form-select v-model="electiveToEdit.assistantTeachersSelected" :options="teachers" value-field="id" text-field="fullName"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="¿Tiene evaluación semestral?">
              <b-form-checkbox switch  v-model="electiveToEdit.extraPeriodEvaluation"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4">
            <b-form-group label="Seleccionar Sistema de evaluación:">
              <b-form-select v-model="electiveToEdit.range.idQualificationSystem" :options="evaluationSystems" :disabled="true"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Seleccionar rango de valoración:">
              <b-form-select v-model="electiveToEdit.idQualificationRange" :options="ranges"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" v-if="checkEvaluationSystem(electiveToEdit.range.idQualificationSystem, 'QUANTITATIVE')">
            <b-form-group label="Seleccionar la planilla de evaluación:">
              <b-form-select v-model="electiveToEdit.templateGradeSelected" :options="templateGradeOptions"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button @click="$bvModal.hide('edit-elective')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
    <b-modal id="log-electiveDeleted" no-enforce-focus ref="modal" title="Resumen de la eliminación" hide-footer size="lg">
      <b-row class="justify-content-center mb-1">
        <b style="font-size: 1.3em;">La electiva fue eliminada exitosamente <i class="fa fa-check text-green" /></b>
      </b-row>
      <b-row class="justify-content-center mb-2" v-for="(value, key) in electiveDeletedInfo" v-bind:key="key.id">
        <b>{{ value }} </b>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import axios from 'axios'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'
const columns = [
  { key: 'id', label: 'Código' },
  { key: 'name', label: 'Nombres' },
  { key: 'evaluationSystem', label: 'S. Evaluación', thClass: 'text-center', tdClass: 'text-center' },
  { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
]

export default {
  name: 'ManagementArea',
  data() {
    return {
      templateGradeOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: 1, text: 'Evaluación 20%, Feedback 20%, STEM 30%, Seguimiento 30%' },
        { value: 2, text: 'Evaluación 20%, Feedback 20%, Proyecto de área 30%, Seguimiento 30%' },
        { value: 3, text: 'Evaluación 30%, Seguimiento 70%' },
        { value: 4, text: 'Seguimiento 100%' },
        { value: 5, text: 'Proyecto 30%, Seguimiento 70%' },
        { value: 6, text: 'Evaluación 40%, Proyecto 40%, Seguimiento 20%' },
      ],
      form: {
        name: '',
        description: '',
        idQualificationRange: null,
        templateGradeSelected: null,
        extraPeriodEvaluation: false,
        range: {
          idQualificationSystem: null,
        },
        subjectSelected: null,
        tenuredTeachersSelected: null,
        assistantTeachersSelected: null,
      },
      electiveDeletedStatus: false,
      electiveDeletedInfo: {},
      subjects: [],
      teachers: [],
      data: [],
      columns,
      electiveToEdit: {
        name: '',
        description: '',
        subjectSelected: {
          name: '',
        },
        range: {
          idQualificationSystem: null,
        },
        idQualificationRange: null,
        templateGradeSelected: null,
        extraPeriodEvaluation: false,
        tenuredTeachersSelected: '',
        assistantTeachersSelected: '',
      },
      ranges: [],
      evaluationSystems: [],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    function getSubjects() {
      return apiClient.get('/subjects')
    }

    function getTeachers() {
      return apiClient.get('/users?roles=6&fields=id,name,lastName&orderField=firstLastName')
    }

    function getElectives() {
      return apiClient2.get('/electives')
    }

    function getQualificationRange() {
      return apiClient.get('/qualifications/assessments')
    }

    function getEvaluationSystems() {
      return apiClient2.get('/evaluationSystems')
    }

    axios.all([getSubjects(), getTeachers(), getElectives(), getQualificationRange(), getEvaluationSystems()])
      .then(axios.spread(function (subjects, teachers, electives, ranges, systems) {
        next((vm) => {
          vm.setDataSubjects(null, subjects.data)
          vm.setDataTeachers(null, teachers.data)
          vm.setDataElectives(null, electives.data.data)
          vm.setDataRanges(null, ranges.data.rows)
          vm.setDataEvaluationSystems(null, systems.data.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataSubjects(err, [])
          vm.setDataTeachers(err, [])
          vm.setDataElectives(err, [])
          vm.setDataRanges(err, [])
          vm.setDataEvaluationSystems(err, [])
        })
      })
  },
  watch: {
    'form.idQualificationRange': function (value) {
      for (const range of this.ranges) {
        if (range.value === value) {
          this.form.range = {
            id: range.value,
            idQualificationSystem: (range.idQualificationSystem) ? range.idQualificationSystem : null,
            name: range.text,
          }
        }
      }
    },
    'electiveToEdit.idQualificationRange': function (value) {
      for (const range of this.ranges) {
        if (range.value === value) {
          this.electiveToEdit.range = {
            id: range.value,
            idQualificationSystem: (range.idQualificationSystem) ? range.idQualificationSystem : null,
            name: range.text,
          }
        }
      }
    },
  },
  methods: {
    setDataSubjects (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.subjects = data
      }
    },
    setDataTeachers(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.teachers = data.map(e => {
          e.fullName = this.getFullName(e)
          return e
        })
      }
    },
    setDataElectives(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data
      }
    },
    setDataRanges(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        if (data.length > 0) {
          this.ranges = data.map(x => {
            return {
              value: x.id,
              text: x.name,
              type: x.system.name,
              idQualificationSystem: x.idQualificationSystem,
            }
          })
          this.ranges.unshift({ value: null, text: 'Seleccione un rango' })
        }
      }
    },
    setDataEvaluationSystems(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.evaluationSystems = data.map((system) => {
          return {
            value: system.id,
            text: system.name,
          }
        })
        this.evaluationSystems.unshift(
          { value: null, text: 'Seleccione una opción' },
        )
      }
    },
    checkEvaluationSystem(inputSystem, desired) {
      for (const system of this.evaluationSystems) {
        if (system.value === inputSystem) {
          return system.text === desired
        }
      }
      return false
    },
    getFullName(user) {
      if (user !== false) {
        let fullName = user.firstLastName
        if (user.secondLastName !== null && user.secondLastName.length > 1) {
          fullName += ' ' + user.secondLastName
        }
        fullName += ' ' + user.firstName
        if (user.secondName !== null && user.secondName.length > 1) {
          fullName += ' ' + user.secondName
        }
        return fullName
      }
    },
    save(evt) { // Guarda un grado llamando a la API
      evt.preventDefault()
      if (this.form.assistantTeachersSelected) {
        this.form.idAssistantTeacher = this.form.assistantTeachersSelected.id
      }
      if (this.form.tenuredTeachersSelected) {
        this.form.idTenuredTeacher = this.form.tenuredTeachersSelected.id
      }
      if (this.form.subjectSelected) {
        this.form.idSubject = this.form.subjectSelected.id
      }
      apiClient2.post('/electives', this.form).then(response => {
        this.data.push(response.data.data)
        this.form.name = ''
        this.form.description = ''
        this.form.idQualificationRange = null
        this.form.templateGradeSelected = null
        this.form.extraPeriodEvaluation = false
        this.form.range = {
          idQualificationSystem: null,
        }
        this.form.subjectSelected = null
        this.form.tenuredTeachersSelected = null
        this.form.assistantTeachersSelected = null
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `La electiva ${response.data.data.name} fue creada con éxito.`,
        })
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    openModal(electiveIn) { // Abre el modal para editar una electiva
      electiveIn.range = (electiveIn.range) ? electiveIn.range : { idQualificationSystem: null }
      this.electiveToEdit = { ...electiveIn }
      this.electiveToEdit.tenuredTeachersSelected = electiveIn.idTenuredTeacher
      this.electiveToEdit.assistantTeachersSelected = electiveIn.idAssistantTeacher
      this.electiveToEdit.subjectSelected = electiveIn.idSubject
      if (this.electiveToEdit.idTemplateGrade > 0) {
        this.electiveToEdit.templateGradeSelected = this.electiveToEdit.idTemplateGrade
      }
      this.$bvModal.show('edit-elective')
    },
    deleteModal(electiveIn) {
      Swal.fire({
        title: '¿Desea eliminar la electiva ' + electiveIn.name + '?',
        html: 'Se borrarán también notas relacionadas a la misma y sus registros <b style="color: red;">PERMANENTEMENTE</b>',
        icon: 'warning',
        buttonsStyling: false,
        showCancelButton: true,
        showDenyButton: true,
        customClass: {
          confirmButton: 'btn btn-danger mb-2 mr-2',
          denyButton: 'btn btn-outline-danger mb-2 mr-2',
          cancelButton: 'btn mr-2 mb-3 mt-3 btn-light btn-sm',
        },
        confirmButtonText: '<i class="fa fa-user-times mr-1"></i>Eliminar permanente',
        denyButtonText: '<i class="fa fa-user-times mr-1"></i>Enviar a la papelera',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          const forceDelete = '?forceDelete=true'
          this.deleteElective(electiveIn, forceDelete)
        } else if (result.isDenied) {
          const forceDelete = ''
          this.deleteElective(electiveIn, forceDelete)
        }
      })
    },
    async deleteElective(electiveIn, forceDelete) {
      await apiClient2.delete(`/electives/${electiveIn.id + forceDelete}`).then(status => {
        let messageInfo = 'La electiva fue eliminada exitosamente'
        const info = status.data
        for (const state in info) {
          if (!info[state].includes('Eliminada satisfactoriamente') && !info[state].includes('Eliminadas satisfactoriamente') && !info[state].includes('Eliminados satisfactoriamente')) {
            this.electiveDeletedStatus = false
            messageInfo = 'Se encontraron inconsistencias'
          }
        }
        this.$notification.info({
          message: messageInfo,
        })
        this.electiveDeletedInfo = status.data
        this.search()
        this.$bvModal.show('log-electiveDeleted')
      }).catch(e => {
        Swal.fire('Ooops ocurrio un error', ` ${showErrorMessage(e)} `, 'error')
      })
    },
    search() {
      apiClient2.get('/electives').then(response => {
        this.data = response.data.data
      })
    },
    editElective(evt) { // Edita una electiva llamando a la API
      evt.preventDefault()
      if (this.electiveToEdit.assistantTeachersSelected) {
        this.electiveToEdit.idAssistantTeacher = this.electiveToEdit.assistantTeachersSelected
      }
      if (this.electiveToEdit.tenuredTeachersSelected) {
        this.electiveToEdit.idTenuredTeacher = this.electiveToEdit.tenuredTeachersSelected
      }
      if (this.electiveToEdit.subjectSelected) {
        this.electiveToEdit.idSubject = this.electiveToEdit.subjectSelected
      }
      if (this.electiveToEdit.templateGradeSelected) {
        this.electiveToEdit.idTemplateGrade = this.electiveToEdit.templateGradeSelected
      }
      apiClient2.put('/electives/' + this.electiveToEdit.id, this.electiveToEdit).then(response => {
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó la electiva ${response.data.name} correctamente.`,
        })
        this.search()
        this.$bvModal.hide('edit-elective')
      }).catch(err => {
        this.$notification.warning({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    onReset(evt) {
      evt.preventDefault()
      this.form.name = ''
      this.form.description = ''
      this.form.idQualificationRange = null
      this.form.templateGradeSelected = null
      this.form.extraPeriodEvaluation = false
      this.form.range = {
        idQualificationSystem: null,
      }
      this.form.subjectSelected = null
      this.form.tenuredTeachersSelected = null
      this.form.assistantTeachersSelected = null
    },
  },
}
</script>
